var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.591 8.15901C11.4697 9.03769 11.4697 10.4623 10.591 11.341C9.71231 12.2197 8.28769 12.2197 7.40901 11.341C6.53033 10.4623 6.53033 9.03769 7.40901 8.15901C8.28769 7.28033 9.71231 7.28033 10.591 8.15901",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 18.5V5.541C2.5 4.414 3.414 3.5 4.541 3.5H20.5C21.605 3.5 22.5 4.395 22.5 5.5V18.5C22.5 19.605 21.605 20.5 20.5 20.5H4.5C3.395 20.5 2.5 19.605 2.5 18.5Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M15.5 9.5H19.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M17.9 13.5H15.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M12.5953 16.5C12.4203 16.061 12.1503 15.667 11.8033 15.346V15.346C11.2163 14.802 10.4463 14.5 9.64627 14.5H8.35427C7.55427 14.5 6.78427 14.802 6.19727 15.346V15.346C5.85027 15.667 5.58027 16.061 5.40527 16.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSin);
export default __webpack_public_path__ + "static/media/User-sin.07e05f8678e9195afe3d6b00aac7ec65.svg";
export { ForwardRef as ReactComponent };